<script setup lang="ts">
import { useI18n } from "vue-i18n";

const props = defineProps<{
  closeDialog: () => void;
}>();
const { t } = useI18n();
</script>

<template>
  <v-btn
    v-tippy="t('generic.tooltip.close')"
    icon
    size="x-small"
    variant="text"
    class="tw:!absolute tw:top-3 tw:right-3 tw:z-modal-overlay tw:rounded-full tw:text-on-surface/70 tw:transition-all tw:duration-200 hover:tw:bg-on-surface/10 hover:tw:text-on-surface"
    :aria-label="t('generic.tooltip.close')"
    data-testid="close-dialog-button"
    @click="props.closeDialog"
  >
    <v-icon
      size="16"
      icon="mdi-close"
    />
  </v-btn>
</template>
